import * as angular from "angular";

export class PlanningTemplateDefaultDraftRequestsService {

  constructor(private PlanningTemplatesDefaultDraftAPI, private $planningTemplatesDefaultDraft) {
  }

  getDefaultDraftTemplates(ids?: string[], limit?: number, cursor?: string) {
    const api = this.PlanningTemplatesDefaultDraftAPI.actions.getDefaultDraftTemplates;
    const params: any = {};
    if (ids && ids.length) { params.ids = ids; }
    if (typeof limit === 'number') { params.limit = limit; }
    if (cursor) { params.cursor = cursor; }
    return this.call(api, params, {}, {});
  }

  getDefaultDraftTemplate(id) {
    const api = this.PlanningTemplatesDefaultDraftAPI.actions.getDefaultDraftTemplate;
    return this.call(api, {}, {}, {id: id});
  }

  createDefaultDraftTemplate(payload) {
    const api = this.PlanningTemplatesDefaultDraftAPI.actions.createDefaultDraftTemplate;
    return this.call(api, {}, payload, {});
  }

  updateDefaultDraftTemplate(payload) {
    const api = this.PlanningTemplatesDefaultDraftAPI.actions.updateDefaultDraftTemplate;
    return this.call(api, {}, payload, {id: payload.id});
  }


  private call(_apiCall, _params, _data, _options) {
    return this.$planningTemplatesDefaultDraft().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.planning')
  .service('planningTemplateDefaultDraftRequestsService', PlanningTemplateDefaultDraftRequestsService);
